<template>
    <div class="notification-bar">
        <transition mode="out-in"
                  :css="false"
                  @enter="enter"
                  @leave="leave"
        >
            <notification :data="notification"
                          :key="notification.id"
                          v-if="notification"
            >
            </notification>
        </transition>
    </div>
</template>

<script>
import { TweenLite } from 'gsap';
import Notification from './Notification';

export default {
    components: {
        Notification
    },
    computed: {
        notification() {
            return this.$store.getters['notifications/current'];
        }
    },
    methods: {
        enter(el, done) {
            TweenLite.to(el, 0.3, {
                y: '-100%',
                onComplete: done
            });
        },
        leave(el, done) {
            TweenLite.to(el, 0.3, {
                y: '100%',
                onComplete: done
            });
        }
    }
};
</script>

<style scoped lang="scss">
    .notification-bar {
        position: fixed;
        z-index: 99999;
        bottom: 0;
        right: 0;
        width: 100%;
        max-width: 100%;

        @include medium {
            width: 19rem;
            right: 0.625rem;
            bottom: 0.625rem;
        }

        @include extra-large {
            width: 600px;
            right: 1.25rem;
            bottom: 1.25rem;
        }
    }
</style>
